var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.display)?_c('a',{staticClass:"apply-button",attrs:{"href":_vm.url}},[_c('div',{staticClass:"button-copy"},[_vm._v("\n        "+_vm._s(_vm.text)+"\n    ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }